import { render, staticRenderFns } from "./ItemsListFilters.vue?vue&type=template&id=53993c88"
import script from "./ItemsListFilters.vue?vue&type=script&lang=js"
export * from "./ItemsListFilters.vue?vue&type=script&lang=js"
import style0 from "./ItemsListFilters.vue?vue&type=style&index=0&id=53993c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports